export default {
  state: {
    vehicleStatusList: [],
    statusList: [{ id: 0, name: '开口' }, { id: 1, name: '关闭' }],
    typeList: [{ id: 1, name: '出厂开口项' }, { id: 2, name: '出质保开口项' }, { id: 3, name: '预验收开口项' }],
    rectificationList: [{ id: 0, name: '待领取任务' }, { id: 1, name: '待填写完工工单' }, { id: 2, name: '待审核完工工单' }, { id: 3, name: '已审核通过' }, { id: 4, name: '待修改完工工单' }, { id: 5, name: '待修改电子工单' }],
    openTypeList: [],
    causationList: [],
    departmentList: [],
    correctionList: [],
    operatorList: [],
    workerList: [],
    showType: Number,
    openItemId: Number

  },
  getters: {
    vehicleStatusList: state => state.vehicleStatusList,
    statusList: state => state.statusList,
    typeList: state => state.typeList,
    rectificationList: state => state.rectificationList,
    openTypeList: state => state.openTypeList,
    causationList: state => state.causationList,
    departmentList: state => state.departmentList,
    correctionList: state => state.correctionList,
    operatorList: state => state.operatorList,
    workerList: state => state.workerList,
    showType: state => state.showType,
    openItemId: state => state.openItemId
  },
  mutations: {
    vehicleStatusList (state, data) {
      state.vehicleStatusList = data
    },
    openTypeList (state, data) {
      state.openTypeList = data
    },
    causationList (state, data) {
      state.causationList = data
    },
    departmentList (state, data) {
      state.departmentList = data
    },
    correctionList (state, data) {
      state.correctionList = data
    },
    operatorList (state, data) {
      state.operatorList = data
    },
    workerList (state, data) {
      state.workerList = data
    },
    showType (state, data) {
      state.showType = data
    },
    openItemId (state, data) {
      state.openItemId = data
    }
  },
  actions: {
    handleVehicleStatusList (vehicleStatusList, data) {
      vehicleStatusList.commit('vehicleStatusList', data)
    },
    handleOpenTypeList (openTypeList, data) {
      openTypeList.commit('openTypeList', data)
    },
    handleCausationList (causationList, data) {
      causationList.commit('causationList', data)
    },
    handleDepartmentList (departmentList, data) {
      departmentList.commit('departmentList', data)
    },
    handleCorrectionList (correctionList, data) {
      correctionList.commit('correctionList', data)
    },
    handleOperatorList (operatorList, data) {
      operatorList.commit('operatorList', data)
    },
    handleWorkerList (workerList, data) {
      workerList.commit('workerList', data)
    },
    handleShowType (showType, data) {
      showType.commit('showType', data)
    },
    handleOpenItemId (openItemId, data) {
      openItemId.commit('openItemId', data)
    }

  }
}
